import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (params) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '',
    name: 'inspectionItemGet',
    method: 'GET'
  });
  useEffect(() => {
    if (params) {
      let url = `/api/inspection/item?is_deleted=0`;
      Object.keys(params).forEach((key) => {
        url += `&${key}=${params[key]}`;
      });
      exec(url);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [isRequestSuccessed, data || [], exec];
})